import { Bruger } from '../models/Bruger';
import * as jwt_decode from 'jwt-decode';
import { BrugerRolleEnum } from '../models/enums/BrugerRolleEnum';
import { OpgaveBedoemmesAfEnum } from '../models/enums/OpgaveBedoemmesAfEnum';

export function getLoggedInBruger(): Bruger {
  const token = localStorage.getItem('token');

  if (token == null) {
    throw new Error('Token ikke fundet lokalt');
  }
  const decodedToken: any = jwt_decode(token);
  let bruger = new Bruger();
  bruger = JSON.parse(decodedToken.bruger);

  return bruger;
}

export function getLoggedInUniLoginRefreshToken(): string {
  const token = localStorage.getItem('token');

  if (token == null) {
    throw new Error('Token ikke fundet lokalt');
  }
  const decodedToken: any = jwt_decode(token);

  return decodedToken.uniLoginRefreshToken;
}

export function getLoggedInUniLoginIdToken(): string {
  const token = localStorage.getItem('token');

  if (token == null) {
    throw new Error('Token ikke fundet lokalt');
  }
  const decodedToken: any = jwt_decode(token);

  return decodedToken.uniLoginIdToken;
}

export function getUniLoginTokenExpires(): number | null {
  const token = localStorage.getItem('token');

  if (token == null) {
    return null;
  }
  const decodedToken: any = jwt_decode(token);
  const decodedUniLogin: any = jwt_decode(decodedToken.uniLoginToken);

  return decodedUniLogin.exp;
}

export function getBrugerDisplayName(): string {
  let loggedInBrugerCaption = '';
  let bruger = getLoggedInBruger();
  if (bruger !== undefined) {
    let rollenavn = '';
    if (bruger.rolle === BrugerRolleEnum.Elev) {
      rollenavn = 'elev';
    } else if (bruger.rolle === BrugerRolleEnum.Laerer) {
      rollenavn = 'lærer';
    } else if (bruger.rolle === BrugerRolleEnum.Administrator) {
      rollenavn = 'admin';
    } else if (bruger.rolle === BrugerRolleEnum.Ekstern) {
      rollenavn = 'bruger';
    } else {
      throw new Error('Ukendt rolle: ' + bruger.rolle);
    }
    loggedInBrugerCaption =
      bruger.navn === null
        ? bruger.brugernavn + ', ' + rollenavn
        : bruger.navn + ', ' + rollenavn;
  }

  return loggedInBrugerCaption;
}

export function isAuthenticated(): boolean {
  const token = localStorage.getItem('token');

  if (token == null) {
    return false;
  }

  const decodedToken: any = jwt_decode(token);
  const expirationDateAsString: number = decodedToken.exp;

  const expirationDate = new Date(expirationDateAsString * 1000);

  return new Date() < expirationDate;
}

export function canImpersonate(): boolean {
  const token = localStorage.getItem('token');

  if (token == null) {
    return false;
  }

  const decodedToken: any = jwt_decode(token);
  return decodedToken.canImpersonate.toLowerCase() === 'true';
}

export function erKonkurrenceDag(konkurrenceDag: Date | undefined): boolean {
  return (
    konkurrenceDag !== undefined &&
    new Date(konkurrenceDag).toDateString() === new Date().toDateString()
  );
}

export function maaBedoemme(
  konkurrenceDag: Date | undefined,
  opgavenBedoemmesAf: OpgaveBedoemmesAfEnum
): boolean {
  const erKonkurrenceIdag = erKonkurrenceDag(konkurrenceDag);
  var bruger = getLoggedInBruger();

  if (erKonkurrenceIdag) {
    if (bruger.rolle === BrugerRolleEnum.Administrator) {
      return true;
    }

    var bedoemmesAfValue = undefined;
    switch (bruger.rolle) {
      case BrugerRolleEnum.Elev:
        bedoemmesAfValue = OpgaveBedoemmesAfEnum.Elever;
        break;
      case BrugerRolleEnum.Laerer:
      case BrugerRolleEnum.Ekstern:
        bedoemmesAfValue = OpgaveBedoemmesAfEnum.EksterneLaerer;
        break;
      default:
        return false;
    }

    return opgavenBedoemmesAf === bedoemmesAfValue;
  }

  return false;
}

export function isImpersonating(): boolean {
  const token = localStorage.getItem('token');

  if (token == null) {
    return false;
  }

  const decodedToken: any = jwt_decode(token);
  return decodedToken.isImpersonating.toLowerCase() === 'true';
}

export function erElev(): boolean {
  const bruger = getLoggedInBruger();

  if (bruger.rolle === BrugerRolleEnum.Elev) {
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/Security.ts